var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33335 16.6666C2.87502 16.6666 2.48266 16.5035 2.15627 16.1771C1.82988 15.8507 1.66669 15.4583 1.66669 15V4.99998C1.66669 4.54165 1.82988 4.14929 2.15627 3.8229C2.48266 3.49651 2.87502 3.33331 3.33335 3.33331H16.6667C17.125 3.33331 17.5174 3.49651 17.8438 3.8229C18.1702 4.14929 18.3334 4.54165 18.3334 4.99998V15C18.3334 15.4583 18.1702 15.8507 17.8438 16.1771C17.5174 16.5035 17.125 16.6666 16.6667 16.6666H3.33335ZM10 10.8333L3.33335 6.66665V15H16.6667V6.66665L10 10.8333ZM10 9.16665L16.6667 4.99998H3.33335L10 9.16665ZM3.33335 6.66665V4.99998V15V6.66665Z",
    fill: "#333333"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotations);
export default __webpack_public_path__ + "static/media/quotations.69c8da196ca535da09b3bd54a220ad38.svg";
export { ForwardRef as ReactComponent };